import React from "react";
import { useHistory, useLocation } from "react-router";

import { Container, FadeInContainer, TestWrapper } from "@ui/Atoms";
import { HeaderTabsWLinks } from "@ui/Molecules";

import { useFeatureToggle } from "@hooks/useFeatureToggle";

import { ProfileLayoutFeatureToggleProps } from "./ProfileLayoutFeatureToggle.types";
import * as Styled from "./ProfileLayoutFeatureToggle.styled";

export const ProfileLayoutFeatureToggle: React.FC<
  ProfileLayoutFeatureToggleProps
> = props => {
  const isNewDashboardUIEnabled = useFeatureToggle("pwa_client_dashboard_v2");
  const history = useHistory();
  const location = useLocation();

  return (
    <React.Fragment>
      {isNewDashboardUIEnabled && (
        <Styled.Root>
          <Styled.TabsUnderline>
            <Container>
              <Styled.ProfileNavigationTabs>
                {props.tabs.map(tab => {
                  return (
                    <Styled.ProfileNavigationTab
                      key={tab.to}
                      testId={tab.testId}
                      active={location.pathname === tab.to}
                      onClick={() => history.push(tab.to)}
                    >
                      {tab.icon && <tab.icon />}
                      {tab.label}
                    </Styled.ProfileNavigationTab>
                  );
                })}
              </Styled.ProfileNavigationTabs>
            </Container>
          </Styled.TabsUnderline>

          <Container>
            <Styled.TabContent>{props.children}</Styled.TabContent>
          </Container>
        </Styled.Root>
      )}

      {!isNewDashboardUIEnabled && (
        <Container>
          <HeaderTabsWLinks tabs={props.tabs} />
          <FadeInContainer>{props.children}</FadeInContainer>
        </Container>
      )}
    </React.Fragment>
  );
};
